// export const BACKEND_PATH = import.meta.env.DEV ? <const>`https://localhost` : <const>``;
export const BACKEND_PATH = import.meta.env.DEV
	? <const>`http://localhost:${import.meta.env.VITE_BACKEND_PORT || 3001}`
	: <const>``;

export const SOCKET_GAME_PATH = <const>`${BACKEND_PATH}/game`;
export const SOCKET_CHAT_PATH = <const>`${BACKEND_PATH}/social`;
